import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ComplianceBadge from "./ComplianceBadge";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/sif", label: "SIF" },
    { path: "/contact", label: "Contact" }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed w-full top-0 z-50 bg-[#0d1117]/60 backdrop-blur-xl border-b border-[#d4af69]/10" data-testid="header" role="banner">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-[#d4af69] text-[#0d1117] px-4 py-2 rounded-md z-50">
        Skip to main content
      </a>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center gap-4 group" data-testid="logo-link" aria-label="Kredere Family Office Home">
            <div className="flex flex-col">
              <span className="text-3xl font-light tracking-wider text-[#d4af69] group-hover:text-[#e8c488] transition-colors" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                KREDERE
              </span>
              <span className="text-[10px] tracking-[0.2em] text-gray-500 uppercase mt-0.5">Family Office</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-12" role="navigation" aria-label="Main navigation">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`text-sm tracking-wider uppercase font-light transition-all relative group ${
                  isActive(item.path) ? "text-[#d4af69]" : "text-gray-400 hover:text-[#d4af69]"
                }`}
              >
                {item.label}
                <span className={`absolute -bottom-1 left-0 h-px bg-[#d4af69] transition-all ${
                  isActive(item.path) ? "w-full" : "w-0 group-hover:w-full"
                }`}></span>
              </Link>
            ))}
          </nav>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-400 hover:text-[#d4af69] transition-colors"
            data-testid="mobile-menu-button"
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-6" data-testid="mobile-menu" id="mobile-menu">
            <nav className="flex flex-col gap-6" role="navigation" aria-label="Mobile navigation">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-sm tracking-wider uppercase font-light transition-colors ${
                    isActive(item.path) ? "text-[#d4af69]" : "text-gray-400 hover:text-[#d4af69]"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="mt-6 pt-6 border-t border-[#d4af69]/10">
              <ComplianceBadge variant="minimal" />
            </div>
          </div>
        )}
      </div>
    </header>
  );
}